import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from '../dashboard.service';
import { UserTypeList } from '../Models/usertypelist.model';
import { AuthService } from 'app/auth/auth.service';
import { LanguageService } from 'app/shared/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface DialogData {
  id: string;
  name: string;
  usertypeid: number;
  userid: number;
  prelocationid: number;
  usertype: string;
}

@Component({
  selector: 'app-patient-move-dialog',
  templateUrl: './patient-move-dialog.component.html',
  styleUrls: ['./patient-move-dialog.component.scss']
})
export class PatientMoveDialogComponent implements OnInit {
  dataSource = new MatTableDataSource<UserTypeList>();
  destroymove$: Subject<boolean> = new Subject<boolean>();
  constructor(private dialogRef: MatDialogRef<PatientMoveDialogComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData, private dashboardService: DashboardService,
    private translate: TranslateService,
    private langservice: LanguageService,) {
    dialogRef.disableClose = true;
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
  }

  displayedColumns: string[] = ['userName', 'waitingFresh', 'waitingReview', 'totalWaiting', 'totalwait','seen', 'Roomno', 'speciality',
  ];

  ngOnInit() {
    this.dataSource.data = this.dashboardService.usertype_list;

  }
  getTotal(column: string): number {
   
    return this.dataSource.data?.reduce((acc, curr) => acc + (curr[column] || 0), 0);
  }
  ngOnDestroy() {
    this.destroymove$.next(true);
    this.destroymove$.unsubscribe();
    this.displayedColumns = null;
    this.dataSource = null;

  }
  onNoClick(): void {
    this.dashboardService.selectedRowIndex = -1;
    this.dashboardService.popup_cancel = true;
    this.dialogRef.close();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }
  getstatus(isloggedin: boolean) {
    if (isloggedin == true) {
      return "Yes";
    }

    else {
      return "No";
    }
  }
  getcolor(isloggedin: boolean) {
    if (isloggedin == true) {
      return "badge badge-success";
    }
    else {
      return "badge badge-danger";
    }
  }
  getrowscolor() {

    return this.dashboardService.getlocationcolor(this.data.usertypeid);

  }
  movepatient(selecteduserid: number, shortname: string, roomName: any, loginroomId: number) {
    this.dashboardService.open_loader_Dialog();
    this.dashboardService.getlocationType(this.data.id, selecteduserid, this.data.usertypeid, this.authService.Loggeduser.branchid, this.data.prelocationid, this.data.usertypeid, shortname).pipe(takeUntil(this.destroymove$)).

      subscribe(data => this.success_patient_moved(data, roomName, loginroomId),
        err => this.failed_patient_moved(err));
  }

  success_patient_moved(data, roomName: any, loginroomId) {
    this.dashboardService.popup_cancel = false;
    let payload = {
      roomName: roomName,
      loginroomId: loginroomId
    }
    this.dialogRef.close(payload);
   
    let isdailated =this.dashboardService.selectedPatient.isDilated || 0;
    if (this.data.usertypeid == 6 && isdailated ==1) {
      this.dashboardService.finishdilation(this.data.id);
    }

    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg4'], this.authService.validationMsg['Ok']);
  }
  failed_patient_moved(err) {
    this.dashboardService.popup_cancel = false;
    this.dialogRef.close();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg4'], this.authService.validationMsg['Ok']);
    }
  }

  chkspeciality(speciality: string) {
    if (speciality == null || speciality == "") {

      return "NO DATA";
    }
    else {
      return speciality;
    }
  }
  chkroomno(roomno: string) {
    if (roomno == "" || roomno == null) {
      return "No";
    }
    else {
      return roomno;
    }
  }

}
